export default "__VITE_ASSET__a1230551__"